import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  closeButton: {
    position: 'absolute',
    right: 0,
    top: 0,
    color: '#fff',
    background: '#5250F9',
    borderRadius: '0px 30px',
    width: 45,
    height: 55,
    "&:hover": {
      background: "#3433B8"
    },
  }
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon style={{color: '#fff'}}/>
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

function Modal({ title, children, ...rest }) {
  return (
    <Dialog fullWidth scroll="body" {...rest}>
      <DialogTitle onClose={rest.onClose}>{title}</DialogTitle>
      {children}
    </Dialog>
  );
}

export default Modal;
